import { faPen, faQuestionCircle, faUserCheck, faCheckCircle, faTimesCircle, faSignInAlt, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import moment from 'moment';
import React, { useContext, useEffect, useState, useMemo } from 'react';
import { ModalContext } from '../Library/ModalContext'
import { Table, Button,Row,Col,Form } from 'react-bootstrap';
import { LanguageContext } from '../Language/LanguageContext';
import { TablePagination, Loading, HeaderTitle } from '../Library';
import { listVisitorReport } from '../Network/Visitor';
import "./VisitorReport.css"
import axios from 'axios'
import { wtc5214,visitor8082 } from '../Network/Config'
import DatePicker from "react-datepicker";
import { valueContainerCSS } from 'react-select/dist/index-fe3694ff.cjs.dev';

function useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const handler = setTimeout(() => setDebouncedValue(value), delay);
        return () => clearTimeout(handler);
    }, [value, delay]);

    return debouncedValue;
}

function VisitorReport({company}) {
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.visitor

    const [isLoading, setIsLoading] = useState(false)
    const [visitorReportList, setVisitorReportList] = useState([])
    const [searchKeyword, setSearchKeyword] = useState("")
    const [isSearching, setIsSearching] = useState(false)
    const [searchContact, setSearchContact] = useState("")
    const [dataVisitor, setDataVisitor] = useState([])
    const [searchDataVisitor, setSearchDataVisitor] = useState([])
    const [imgList, setImgList] = useState([])
    const modal = useContext(ModalContext)
    const [page, setPage] = useState(1)
    const size = 10
    const [count, setCount] = useState(0)
    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null)
    const stableCompany = useMemo(() => company, [company]);
    const debouncedStartDate = useDebounce(startDate, 500);
    const debouncedEndDate = useDebounce(endDate, 500);

    useEffect(() => {
        if (startDate) {
            setEndDate(dayjs().toDate());
        }
    }, [startDate]);
    
    useEffect(() => {
        const fetchData = async ()=>{
            const formData = new FormData();
            formData.append("company_name", stableCompany);

            const formattedStartDate = startDate
                ? dayjs(startDate).format("YYYY-MM-DD")
                : dayjs().format("YYYY-MM-DD");
            const formattedEndDate = endDate
                ? dayjs(endDate).format("YYYY-MM-DD")
                : dayjs().add(1, "day").format("YYYY-MM-DD");

            formData.append("start_date", formattedStartDate);
            formData.append("end_date", formattedEndDate);

            try {
                setIsLoading(true);
                await axios.post(
                    `${visitor8082}/visitor/api/v1/dashboard`,
                    formData
                ).then(
                    function(response){
                        console.log(response.data.reportvisitor);
                        setDataVisitor(response.data.reportvisitor);
                        setIsLoading(false);
                    }
                ).catch(
                    function (error) {
                    setIsLoading(false)
                    console.log(error);
                }
                );
            } catch (error) {
                setIsLoading(false);
                console.error("Error fetching visitor data:", error);
            }
        };
        fetchData();
    }, [stableCompany, debouncedStartDate, debouncedEndDate])

    const changemonth = (months) =>{
        let month = "";
        switch(months){
            case("Jan"):
            month = "ม.ค."
                break
            case("Feb"):
            month = "ก.พ."
                break
            case("Mar"):
            month = "มี.ค."
                break
            case("Apr"):
            month = "เม.ย."
                break
            case("May"):
            month = "พ.ค."
                break
            case("Jun"):
            month = "มิ.ย."
                break
            case("Jul"):
            month = "ก.ค."
                break
            case("Aug"):
            month = "ส.ค."
                break
            case("Sep"):
            month = "ก.ย."
                break
            case("Oct"):
            month = "ต.ค."
                break
            case("Nov"):
            month = "พ.ย."
                break
            case("Dec"):
            month = "ธ.ค."
                break
        }
        return month
    }

    const formattedDate = (date) => {
        const dates =  date.slice(5, 7)
        const months =  changemonth(date.slice(8, 11))
        const years = parseInt(date.slice(12, 16))+543 
        const times = date.slice(17, 22)+ " น."
        const datetime = dates  +" "+ months +" "+ years +" "+ times
        const dateFormatted = datetime
        return dateFormatted
    }

    const VisitorReportItem = ({booking_id, visitorname, username, type, booking_status, entranceDatetime, exitDatetime, topic, img, covid }) => {
        let statusIcon = { icon: faQuestionCircle, text: lang.no_status, color: "gray" }
        switch(booking_status){
            case("approve"):
            statusIcon = { icon: faCheckCircle, text: lang.registered, color: 'green' }
                break
            case("pending approval"):
            statusIcon = { icon: faPen, text: lang.fast_register, color: 'orange' }
                break
            case("reject"):
            statusIcon = { icon: faTimesCircle, text: lang.fast_register, color: 'red' }
                break
            case("checkin"):
            statusIcon = { icon: faSignInAlt, text: lang.fast_register, color: 'blue' }
                break
            case("checkout"):
            statusIcon = { icon: faSignOutAlt, text: lang.fast_register, color: 'purple' }
                break
        }

        return(
            <tr>
                <td>
                    <Button onClick={()=> modalShowImg(visitorname, booking_id) }>ดู</Button>
                </td>
                <td>
                    <FontAwesomeIcon icon={statusIcon.icon} color={statusIcon.color}/>
                </td>
                <td>{visitorname}</td>
                <td>{username}</td>
                <td>{booking_status}</td>
                <td>{formattedDate(entranceDatetime)}</td>
                <td>{formattedDate(exitDatetime)}</td>
                <td>{topic}</td>
            </tr>
        )
    }

    const modalShowImg = async (visitorname, booking_id) =>{
        console.log(booking_id)
        const formData = new FormData();
                formData.append('company_name', stableCompany);
                formData.append('booking_id', booking_id);
                const responseData = await axios.post(visitor8082+'/visitor/api/v1/get_img', formData);
        modal.setHeader(
            <div className='header-modal'>
                ผู้ติดต่อ : {visitorname}
            </div>
        )
        modal.setShow(true)
        modal.setComponent(
            <div className='content-img'>
                { 
                    responseData.data.data.map((item, key)=>{
                        return(
                            <div className='div-img'>
                                <img className='img' src={item.img} />
                            </div>
                        );
                    })
                }
            </div>
         )
        //modal.setDark(false)
    }


    const callData = () => {
        if(isSearching == true){
        return(
            searchDataVisitor?.map( (item, key) =>
                <VisitorReportItem
                        key={key}
                        type={item.type}
                        visitorname={item.visitor_name}
                        username={item.username}
                        booking_status={item.booking_status}
                        entranceDatetime={item.date_time_use}
                        exitDatetime={item.date_time_end}
                        topic={item.topic}
                        img={item.img}
                        covid={item.covid}
                        booking_id={item.booking_id}
                />
                        
            )
        );
        }else{
            return(
                dataVisitor?.map( (item, key) =>
                    <VisitorReportItem
                            key={key}
                            type={item.type}
                            visitorname={item.visitor_name}
                            username={item.username}
                            booking_status={item.booking_status}
                            entranceDatetime={item.date_time_use}
                            exitDatetime={item.date_time_end}
                            topic={item.topic}
                            img={item.img}
                            covid={item.covid}
                            booking_id={item.booking_id}
                    />
                            
                )
            );
        }
    }

    const onSearchVisitor = (e) =>{
        let val = e.target.value.toLowerCase()
        setSearchKeyword(e.target.value)
        if(val.length > 0){
            setIsSearching(true)
            var result = dataVisitor.filter((el)=> { 
                if(val == 'other'){
                    return !el.topic.toLowerCase().includes('ส่งของ') && !el.topic.toLowerCase().includes('ผู้รับเหมา') && !el.topic.toLowerCase().includes('ขอเข้าพื้นที่')
                }
                return el.topic.toLowerCase().includes(val);
            }
            )
            setSearchDataVisitor(result)
        }else{
            setIsSearching(false)
            setSearchDataVisitor([])
        }
        
    }

    const onSearchContact = (e) =>{
        let val = e.target.value.toLowerCase()
        setSearchContact(e.target.value)
        if(val.length > 0){
            setIsSearching(true)
            var result = dataVisitor.filter((el) =>{
                return el.visitor_name.toLowerCase().includes(val);
            }
            )
            setSearchDataVisitor(result)
        }else{
            setIsSearching(false)
        }
    }


    useEffect(()=>{
        const fetchData1 = () => {
            listVisitorReport(page, size,
                (data) => {
                    const content = data.content
                    const count = data.count     
                    setVisitorReportList(content)
                    setCount(count)
                },
                (error) => { 
                    console.log(error)
                },)
        }
        fetchData1()
    },[page, size])


    const exportToExcel = async () =>{
        setIsLoading(true);
        let startDates
        let endDates
        let keyWords
        const formData = new FormData();
            if(startDate == null || endDate == null){
                startDates = dayjs().format("YYYY-MM-DD")
                endDates = dayjs().add(1,'day').format("YYYY-MM-DD")
            }else{
                startDates = dayjs(startDate).format("YYYY-MM-DD")
                endDates = dayjs(endDate).format("YYYY-MM-DD")
            }   
            if(searchKeyword == ''){
                keyWords = 'ส่งของ'
            }else{
                keyWords = searchKeyword
            }
            formData.append('start_date', startDates+' 23:59:59');
            formData.append('end_date', endDates+' 23:59:59');
            formData.append('type', keyWords);
            try{
                const responseData = await axios.post('https://visitor-api.lifelink.co.th:8082/visitor/api/v1/get_report', formData);
                console.log('Get report : ', responseData.data.report)
                if (responseData.data && responseData.data.report) {
                    const reportUrl = responseData.data.report;
                    // Open the link in a new tab
                    window.open(reportUrl, "_self");
                } else {
                    console.error("Invalid API response:", responseData.data);
                }
            }catch (error){
                setIsLoading(false);
                console.error("Error fetching report:", error);
            }finally {
                setIsLoading(false); // Hide loading indicator
            }
        
    }

    return(
        <div id="visitor-report">
            { isLoading ? <Loading/> : null }
            <HeaderTitle
            title={lang.visitor_report_desc}
            style={{fontSize:16}}
            customRight={''
                /*
                <Form.Control
                placeholder={lang.search_visitor}
                onChange={onSearchVisitor}
                value={searchKeyword}
                type="search"
                />*/
            }
            />
            <div style={{paddingTop:10}}>
            <Row>
                <Col md={6} lg={6}>
                            <Form.Group>
                                <Form.Label>{'วันที่เริ่มต้น'}</Form.Label>
                                <div>
                                <DatePicker 
                                selected={startDate}
                                onChange={(date)=>{
                                    setStartDate(date)
                                }}
                                className="form-control" 
                                dateFormat="d MMMM yyyy"
                                placeholderText={'วันที่เริ่มต้น'}
                                maxDate={new Date()}
                                />
                                </div>
                            </Form.Group>
                </Col>
                <Col md={6} lg={6}>
                            <Form.Group>
                                <Form.Label>{'วันที่สิ้นสุด'}</Form.Label>
                                <div>
                                <DatePicker 
                                selected={endDate}
                                onChange={(date)=>{
                                    setEndDate(date)
                                }}
                                className="form-control" 
                                dateFormat="d MMMM yyyy"
                                placeholderText={'วันที่สิ้นสุด'}
                                maxDate={new Date()}
                                minDate={startDate}
                                />
                                </div>
                            </Form.Group>
                </Col>
            </Row>
            <Row style={{justifyContent:'right'}}>
                <Col md={2}>
                <Form.Control
                    placeholder={'ค้นหาจากผู้มาติดต่อ'}
                    onChange={onSearchContact}
                    value={searchContact}
                    type="search"
                />
                </Col>
                <Col style={{justifyItems:'right'}} md={2}>
                    <Form.Control as="select" value={searchKeyword} onChange={onSearchVisitor}>
                        <option value={''}>{'ประเภท'}</option>
                        <option value={'ขอเข้าพื้นที่'}>{'ขอเข้าพื้นที่'}</option>
                        <option value={'ส่งของ'}>{'ส่งของ'}</option>
                        <option value={'ผู้รับเหมา'}>{'ผู้รับเหมา'}</option>
                        <option value={'Other'}>{'อื่น ๆ'}</option>
                    </Form.Control>
                </Col>
                <Col style={{textAlign:'right'}} md={2}>
                    <Button onClick={()=>{exportToExcel()}} style={{width:'100%'}} disabled={startDate != null && endDate != null && searchKeyword != ''? false:true} variant={"success"}>รับไฟล์เอกสาร</Button>
                </Col>
            </Row>
            </div>
            
            <div className='table-container'>
                <Table hover>
                    <thead>
                        <tr>
                            <th></th>
                            <th></th>
                            <th>{lang.visitorname}</th>
                            <th>{lang.username}</th>
                            <th>{lang.type}</th>
                            <th>{lang.entrance_datetime}</th>
                            <th>{lang.exit_datetime}</th>
                            <th>{lang.topic}</th>
                        </tr>
                    </thead>
                    <tbody>
                        { 
                        callData()
                        }
                    </tbody>
                </Table>
            </div>
        </div>
    )
}

export default VisitorReport;
